<template>
  <el-dialog
    :visible.sync="dialogVisible"
    append-to-body
    custom-class="categorypagedialog "
  >
    <img width="100%" :src="imgSrcUrl" alt="">
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      imgSrcUrl: null
    }
  },
  methods: {
    handle(e) {
      this.dialogVisible = true
      this.imgSrcUrl = e
    }
  }
}
</script>
<style scoped>
.el-dialog__wrapper{
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .categorypagedialog{
  max-width: 760px;
  border-radius: 10px;
  padding:0 40px;
  margin-top: 0 !important;
}
 .categorypagedialog .el-dialog__body{
     padding: 10px;
     padding-bottom: 30px;
    display: flex;
    justify-content: center;
  }
.categorypagedialog  .el-dialog__footer{
    bottom: 0;
    left: 0;
    position: absolute;
    width: 100%;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/popupImg.vue